import { Styles } from "../../../../types/common";

const styles: Styles = {
  wrapper: {
    background: "#F0FCF8",
    padding: "24px",
    borderRadius: "12px",
    margin: "40px 0",
    "& .redirect_text": {
      color: "#23085A",
      fontSize: "22px",
      marginBottom: "20px",
    },
  },
};

export default styles;
